// {
// 	"_id": ObjectId("5a8d5627b4f3a36704379757"),
// 	"_class": "com.fusemachines.lms.course.domain.CourseEnrollmentDetails",
// 	"courseId": "5a55af92af19472c4fb0606a",
// 	"courseTitle": "Neural Networks",
// 	"instructorId": "5a55af92af19472c4fb0606b",
// 	"instructorEmail": "smaskey@fusemachines.com",
// 	"studentId": "5a55af92af19472c4fb0606a ",
// 	"studentEmail": "rokin@fusemachines.com",
// 	"enrollmentStatus": "PENDING",
// 	"requestedDate": ISODate("2018-02-21T11:21:11.920+0000"),
// 	"notificationRead": false
// }
export interface NotificationStoreStateType {
  courseId: string
  courseTitle: string
  instructorId: string
  instructorEmail: string
  studentId: string
  studentEmail: string
  enrollmentStatus: string
  notificationRead: string
}

// let notification =
// {
//   courseId: '',
//   courseTitle: '',
//   instructorId: '',
//   instructorEmail: '',
//   studentId: '',
//   studentEmail: '',
//   enrollmentStatus: '',
//   notificationRead: ''
// }
export const NotificationStoreState : Array<NotificationStoreStateType>  = []
